import { BASE_API_URL } from './index';

export const countriesEndpoint = `${BASE_API_URL}/data/reference/countries/`;
